import { Step } from 'react-joyride';

export const zeeProfileSteps: Step[] = [
  {
    target: '.tour-zee-header',
    title: 'Welcome to Zee Profile',
    content:
      'This is your comprehensive franchisee profile dashboard where you can access all information about the franchisee, including their personal details, financials, background, and more.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-brand-score',
    title: 'Brand Match Score',
    content:
      'View the compatibility score between the franchisee and your brand. This score is calculated based on various factors including background, experience, and financial capability.',
    placement: 'left',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-profile-navigation-tabs',
    title: 'Profile Navigation',
    content:
      'Navigate through different sections of the franchisee profile using these tabs. Each tab contains specific information about different aspects of the franchisee.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-basic-profile-info',
    title: 'Basic Profile Information',
    content:
      'Access basic information about the franchisee including contact details, personal information, and preferences.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-financial-info',
    title: 'Financial Information',
    content:
      "Review the franchisee's financial details, including investment capacity, funding sources, and financial qualifications.",
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-background-info',
    title: 'Background Information',
    content:
      "Explore the franchisee's professional background, experience, and qualifications relevant to operating the franchise.",
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-territories-info',
    title: 'Territory Information',
    content:
      'View and manage territories associated with this franchisee, including preferred locations and territory status.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-documents-info',
    title: 'Document Management',
    content:
      'Access all documents related to this franchisee, including signed agreements, submissions, and other important paperwork.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-discovery-info',
    title: 'Discovery Process',
    content:
      "Track the franchisee's progress through the discovery process, including meetings, presentations, and key milestones.",
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-notes-info',
    title: 'Notes and Communications',
    content:
      'Keep track of all communications, notes, and important updates related to this franchisee. Click here.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-notes-title',
    title: 'Notes Overview',
    content:
      'This section provides a comprehensive view of all communications and notes related to the franchisee, organized by category.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.tour-notes-categories',
    title: 'Note Categories',
    content:
      'Filter notes by category including calls, meetings, emails, and general communications. Each tab shows the number of notes in that category.',
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
];
